import React from "react";
import { Button, Container, Form } from "react-bootstrap";

import { IPayloadProps, PayloadSubjectUtils } from "./IPayloadProps";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IPayloadProps) => {
  const subjects = new PayloadSubjectUtils();
  props.signalIfValid(true);
  const preferredClaims =
    props.payload?.claims['org.iso.23220.2'] ??
    props.payload?.claims['org.iso.23220.1'];

  if (props.payload != null) {
    return (
      <Container
        fluid
        style={{
          minHeight: "150px",
          textAlign: "left",
          display: "inline-block",
          width: "50%",
        }}
      >
        <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims.given_name || preferredClaims?.given_name) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput" placeholder="name@example.com" value={preferredClaims ? preferredClaims.given_name + " " + preferredClaims.family_name : props.payload?.claims.given_name + " " + props.payload?.claims.family_name} />
          <label style={{
                width: "470px"
              }}>Name <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
          
        </div>
        </Container>
        <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims.birthdate || preferredClaims?.birth_date) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput" placeholder="name@example.com" value={preferredClaims ? preferredClaims.birth_date : props.payload?.claims.birthdate} />
          <label style={{
                width: "470px"
              }}>Date of Birth <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
         <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims.iat || preferredClaims?.issue_date) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput"  value={preferredClaims ? new Date(preferredClaims.issue_date).toISOString().split('T')[0] : new Date(props.payload?.claims.iat).toISOString().split('T')[0]} />
          <label style={{
                width: "470px"
              }}>Issue Date <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
        <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims.exp || preferredClaims?.expiry_date) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput"  value={ preferredClaims ? new Date(preferredClaims.expiry_date).toISOString().split('T')[0] : new Date(props.payload?.claims.exp).toISOString().split('T')[0]} />
          <label style={{
                width: "470px"
              }}>Expiry Date <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
           <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims.issuing_country || preferredClaims?.issuing_country) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput"  value={preferredClaims ? preferredClaims.issuing_country : props.payload?.claims.issuing_country} />
          <label style={{
                width: "470px"
              }}>Issuing Country <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
        <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims.issuing_authority || preferredClaims?.issuing_authority) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput"  value={preferredClaims ? preferredClaims.issuing_authority : props.payload?.claims.issuing_authority} />
          <label style={{
                width: "470px"
              }}>Issuing Authority <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
        {/* <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: subjects.getSubjects(props.payload)?.placeOfBirth? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput" placeholder="name@example.com" value={subjects.getSubjects(props.payload)?.placeOfBirth} />
          <label style={{
                width: "470px"
              }}>Place of Birth <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
         
        </Container> */}
        <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims?.address?.formatted || preferredClaims?.address?.formatted) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput" placeholder="name@example.com" value={preferredClaims ? preferredClaims.address?.formatted : props.payload?.claims?.address?.formatted} />
          <label style={{
                width: "470px"
              }}>Address <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
        <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims?.email || preferredClaims?.email) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput" placeholder="name@example.com" value={preferredClaims ? preferredClaims.email : props.payload?.claims?.email} />
          <label style={{
                width: "470px"
              }}>Email <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
        <Container style={{width: "400px"}}>
        <div className="form-floating mb-3" style={{display: (props.payload?.claims?.phoneNumber || preferredClaims?.phoneNumber) ? "block": "none"}}>
          <input type="text" disabled style={{backgroundColor: "transparent", width: "400px"}} className="form-control" id="floatingInput" placeholder="name@example.com" value={preferredClaims ? preferredClaims.phoneNumber : props.payload?.claims?.phoneNumber} />
          <label style={{
                width: "470px"
              }}>Phone Number <img
              src="https://www.shutterstock.com/image-vector/checkmark-icon-vector-on-white-600nw-1265668276.jpg"
              className="float-end"
              style={{
                width: "50px"
              }}
            ></img></label>
        </div>
        </Container>
        {!props.showMySSIOnly && (
          <Container style={{ textAlign: "center", marginTop: "20px" }}>
          <Button style={{backgroundColor: "transparent", color: "black"}} type="button" onClick={() =>
              props.authenticateUser ? props.authenticateUser() : null
            }>
                Not you?
              </Button>
        </Container>
        )}
        
      </Container>
    );
  } else {
    return (
      <Container
        fluid
        style={{ minHeight: "150px", width: "80%", margin: "auto" }}
      >
        <Container>
          <Button
          style={{backgroundColor: "rgb(33, 150, 243", color: "white"}}
            onClick={() =>
              props.authenticateUser ? props.authenticateUser() : null
            }
            type="button"
            title="Use mySSI"
          >
            Use Digital ID
          </Button>
        </Container>
        { !props.useMySSIOnly && (
        <Form>
          <br></br>
          <h6>OR</h6>
          <Container fluid style={{ marginTop: "50px", width: "60%" }}>
            <Container>
              <span className="span-6">
                <h3>Personal information</h3>
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="name"
                  placeholder="Name"
                  aria-label="Name"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="birthdate"
                  placeholder="Birthdate"
                  aria-label="Birthdate"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="email"
                  placeholder="Email"
                  aria-label="Email"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="phoneNumber"
                  placeholder="Phone Number"
                  aria-label="Phone Number"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <h3>Address</h3>
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="streetAddress1"
                  placeholder="Street Address"
                  aria-label="StreetAddress1"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="streetAddress2"
                  placeholder="Street Address"
                  aria-label="StreetAddress2"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="postalCode"
                  placeholder="Postal Code"
                  aria-label="Postal Code"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="city"
                  placeholder="City"
                  aria-label="City"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="county"
                  placeholder="County"
                  aria-label="County"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-6">
                <Form.Control
                  name="country"
                  placeholder="Country"
                  aria-label="Country"
                  aria-describedby="basic-addon1"
                />
                <br></br>
              </span>
            </Container>
            <Container>
              <span className="span-12">
                <br></br>
              </span>
            </Container>
          </Container>
        </Form>
        )
        }
        
      </Container>
    );
  }
};
